var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-operate" }, [
    _c(
      "div",
      { staticClass: "c-operate__item" },
      [
        _c("IconByTooltip", {
          staticClass: "iconfont_wrap",
          attrs: {
            data: { ..._vm.copyData, icon: "copyIcon", label: "复制" },
            copyValue: _vm.dataProp.content[0].value,
          },
          on: {
            "on-change": (e) => {
              _vm.copyData.isCopy = false
              _vm.copyData.className = "iconfont icon-a-fuzhimoren"
            },
            "on-click": () => {
              _vm.copyData.isCopy = true
              _vm.copyData.className = "iconfont icon-a-yifuzhimoren"
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }